import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../plugins/axios'
import {AxiosError, AxiosResponse} from "axios";

Vue.use(Vuex)

export class Stamp {
    code = ''
    purchaseDate = ''
    valid = false
}

class State {
    stampCode = ''
    loadingFromApi = false
    stamp: Stamp = new Stamp()
    notFound = false
    serverError = false
    isAuthenticated = false
    username = ''
    password = ''
}

export default new Vuex.Store({
    state: new State(),
    getters: {
        stampCode(state): string {
            return state.stampCode
        },
        stamp(state): Stamp {
            return state.stamp
        },
        isLoading(state): boolean {
            return state.loadingFromApi
        },
        isFound(state): boolean {
            return !state.notFound
        },
        hasServerError(state): boolean {
            return state.serverError
        },
        isAuthenticated(state): boolean {
            if (localStorage.getItem('is-authenticated') === '1') {
                return true
            }
            return state.isAuthenticated
        },
        password(): string | null {
            return localStorage.getItem('token')
        },
        username(): string | null {
            return localStorage.getItem('un')
        }
    },
    mutations: {
        resetStamp(state) {
            state.stamp = new Stamp()
        },
        setStampCode(state, stampCode: string) {
            state.stampCode = stampCode.toUpperCase()
        },
        setStamp(state, stamp: Stamp) {
            state.stamp = stamp
        },
        loadingData(state, isLoading: boolean) {
            state.loadingFromApi = isLoading
        },
        setNotFound(state, isFound: boolean) {
            state.notFound = isFound
        },
        setServerError(state, hasError: boolean) {
            state.serverError = hasError
        },
        setAuthenticationStatus(state, isAuthenticated: boolean) {
            state.isAuthenticated = isAuthenticated
            localStorage.setItem('is-authenticated', '0')
            if (isAuthenticated) {
                localStorage.setItem('is-authenticated', '1')
            }
        },
        setPassword(state, password: string) {
            localStorage.setItem('token', password)
        },
        setUsername(state, username: string) {
            localStorage.setItem('un', username)
        }
    },
    actions: {
        search({commit, state, getters}) {
            commit('loadingData', true)
            commit('resetStamp')
            commit('setNotFound', false)
            axios.get(`stamps/${state.stampCode}`, {
                auth: {
                    username: getters.username,
                    password: getters.password
                }
            })
                .then((resp: AxiosResponse) => {
                    commit('setStamp', resp.data)
                })
                .catch((err: AxiosError) => {
                    if (err.response?.status === 404 || err.response?.status === 400) {
                        commit('setNotFound', true)
                    }
                })
                .finally(() => {
                    commit('loadingData', false)
                })
        },
        invalidate({commit, state, getters}) {
            commit('loadingData', true)
            axios.patch(`stamps/${state.stampCode}`, {}, {
                auth: {
                    username: getters.username,
                    password: getters.password
                }
            })
                .then((resp: AxiosResponse) => {
                    commit('setStamp', resp.data)
                })
                .catch((err: AxiosError) => {
                    if (err.response?.status === 500) {
                        commit('setServerError', true)
                        console.log('Server error: ' + err.response.data.message)
                    }
                })
                .finally(() => {
                    commit('loadingData', false)
                })
        }
    },
    modules: {}
})
